// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sGX1jST9{align-items:center;display:flex;flex-direction:column;flex-grow:1;font-size:.88rem;font-weight:500;justify-content:center;min-height:12rem;opacity:.6;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "sGX1jST9"
};
module.exports = ___CSS_LOADER_EXPORT___;
